import AppRoutes from '../views/config/AppRoutes';

// #cfa1-2027 — keep a 2027 user inside the year-free /cfa1/2027/... tree when the reused
// CFA1-2025 view components navigate internally. Each shared CFA1 route constant maps to its
// /next/ (2027) equivalent; nextAwareRoute() swaps to it only while the current route is under
// /next/, so 2025/2026 navigation is completely unaffected.
const SHARED_TO_NEXT = {
  [AppRoutes.CFA1_2025_DASHBOARD]: AppRoutes.CFA1_2027_NEXT_DASHBOARD,
  [AppRoutes.CFA1_2025_DASHBOARD_VIEW_QUESTIONS]:
    AppRoutes.CFA1_2027_NEXT_DASHBOARD_VIEW_QUESTIONS,
  [AppRoutes.CFA1_2025_NOTES]: AppRoutes.CFA1_2027_NEXT_NOTES,
  [AppRoutes.CFA1_2025_NOTES_READING_LIST]: AppRoutes.CFA1_2027_NEXT_NOTES_READING_LIST,
  [AppRoutes.CFA1_2025_NOTES_VIEW]: AppRoutes.CFA1_2027_NEXT_NOTES_VIEW,
  [AppRoutes.CFA1_2025_NOTES_LIST]: AppRoutes.CFA1_2027_NEXT_NOTES_LIST,
  [AppRoutes.CFA1_VIDEOS]: AppRoutes.CFA1_2027_NEXT_VIDEOS,
  [AppRoutes.CFA1_VIDEO_LIST]: AppRoutes.CFA1_2027_NEXT_VIDEO_LIST,
  [AppRoutes.CFA1_2025_QUESTION_BANK]: AppRoutes.CFA1_2027_NEXT_QUESTION_BANK,
  [AppRoutes.CFA1_2025_QUESTION_BANK_READING_LIST]:
    AppRoutes.CFA1_2027_NEXT_QUESTION_BANK_READING_LIST,
  [AppRoutes.CFA1_2025_QUESTIONS_LIST]: AppRoutes.CFA1_2027_NEXT_QUESTIONS_LIST,
  [AppRoutes.CFA1_2025_QUESTION_VIEW]: AppRoutes.CFA1_2027_NEXT_QUESTION_VIEW,
  [AppRoutes.CFA1_2025_QUIZZES]: AppRoutes.CFA1_2027_NEXT_QUIZZES,
  [AppRoutes.CFA1_2025_QUIZ_BEFORE_START]: AppRoutes.CFA1_2027_NEXT_QUIZ_BEFORE_START,
  [AppRoutes.CFA1_2025_QUIZ_BEGIN]: AppRoutes.CFA1_2027_NEXT_QUIZ_BEGIN,
  [AppRoutes.CFA1_2024_CBT]: AppRoutes.CFA1_2027_NEXT_CBT,
  [AppRoutes.CFA1_2024_CBT_VIEW_ATTEMPTED_MOCK]:
    AppRoutes.CFA1_2027_NEXT_CBT_VIEW_ATTEMPTED_MOCK,
  [AppRoutes.CFA1_2024_CBT_INTRODUCTION]: AppRoutes.CFA1_2027_NEXT_CBT_INTRODUCTION,
  [AppRoutes.CFA1_2024_CBT_QUESTIONS]: AppRoutes.CFA1_2027_NEXT_CBT_QUESTIONS,
  [AppRoutes.CFA1_2024_CBT_QUESTION_FINISH]: AppRoutes.CFA1_2027_NEXT_CBT_QUESTION_FINISH,
  [AppRoutes.CFA1_2024_DETAILED_RESULT_GRAPH]: AppRoutes.CFA1_2027_NEXT_DETAILED_RESULT_GRAPH,
};

const NEXT_PREFIX = '/cfa1/2027';

// Current route path, read straight from the browser URL so it works regardless of the react-router
// history in use: browserHistory keeps the route in window.location.pathname; hashHistory keeps it
// in the hash (#/path). Prefer the hash when present, else the pathname.
export const getCurrentPath = () => {
  const hash = (window.location && window.location.hash) || '';
  if (hash.length > 1) {
    return hash.replace(/^#/, '').split('?')[0];
  }
  return (window.location && window.location.pathname) || '';
};

// True when the current route is inside the 2027 /next/ tree.
export const isNextPath = () => {
  const p = getCurrentPath();
  return !!p && p.indexOf(NEXT_PREFIX) === 0;
};

// Given a shared CFA1 route constant (a route template, e.g. '/cfa1/2026/question-bank/.../view'),
// return the /next/ variant when the user is currently inside the /next/ tree; otherwise return the
// original constant unchanged. Param substitution stays the caller's job — this only swaps the
// template. The current route is read from the browser URL (see getCurrentPath).
export const nextAwareRoute = (routeConstant) => {
  if (isNextPath() && SHARED_TO_NEXT[routeConstant]) {
    return SHARED_TO_NEXT[routeConstant];
  }
  return routeConstant;
};



// WEBPACK FOOTER //
// ./src/common/cfa1NextRoutes.js